import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./WeeklyProgram.css";
import sportgruppenData from "../../data/sportgruppenData";

function WeeklyProgram() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });
    
    // Add this setTimeout to manually refresh AOS after a short delay
    setTimeout(() => {
      AOS.refresh();
    }, 150); // A small delay ensures everything is loaded
  }, []);

  return (
    <section className="weekly-program" id="weekly-program">
      <div className="container">
        <h2 className="section-title" data-aos="fade-up">
          Wochenprogramm
        </h2>
        <div className="program-grid">
          {sportgruppenData.map((item, index) => (
            <div
              className="program-card"
              key={index}
              data-aos="fade-up"
              // Add a slight delay for a nice cascading effect
              data-aos-delay={index * 50} 
            >
              <img src={item.image} alt={item.title} className="program-img" />
              <div className="program-info">
                <h3 className="program-title">{item.title}</h3>
                <a href={`/sportgruppe/${item.id}`} className="program-link">
                  Mehr erfahren →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WeeklyProgram;